import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AccordionModule } from 'primeng/accordion';     //accordion and accordion tab
import { MenuItem } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { TimeagoModule } from 'ngx-timeago';
import { SharedModule } from './modules/shared/shared/shared.module';

import { GroupByPipe } from './pipe/group-by.pipe';
import { CustomTextPipe } from './pipe/custom-text.pipe';
import { UdrNotificationPipe } from './pipe/udrNotification.pipe';
import { EmailMaskPipe } from './pipe/emailMask.pipe';

// import { PackageService } from './service/package.service';
// import { AccountService } from './service/account.service';
import { AdminRoleService } from './service/admin-role.service';
import { AuthGuardService } from './service/auth-guard.service';
import { CustomMinDirective } from './validator/min-validator-directive';
import { CustomMaxDirective } from './validator/max-validator-directive';

import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { AccountManagementComponent } from './account-management/account-management.component';
import { FooterComponent } from './footer/footer.component';
import { ServicePackagesComponent } from './service-packages/service-packages.component';
import { ServicePackageDetailComponent } from './service-package-detail/service-package-detail.component';
// import { LocationsComponent } from './locations/locations.component';
import { AdminRolesComponent } from './admin-roles/admin-roles.component';
import { LocationDetailComponent } from './location-detail/location-detail.component';
import { CompanyProfileComponent } from './company-profile/company-profile.component';
import { LocationSettingsComponent } from './location-settings/location-settings.component';
import { SettingsComponent } from './settings/settings.component';
import { SecurityPoliciesComponent } from './security-policies/security-policies.component';
import { AccountProfileComponent } from './account-profile/account-profile.component';
import { AdminDetailComponent } from './admin-detail/admin-detail.component';
import { SupportComponent } from './support/support.component';
import { UsageComponent } from './usage/usage.component';
import { LoginComponent } from './login/login.component';
import { FmcAdminConsoleComponent } from './fmc-admin-console/fmc-admin-console.component';
import { InsightsComponent } from './fmc/insights/insights.component';
import { FmcDashboardComponent } from './fmc-dashboard/fmc-dashboard.component';
import { ViewServicePackageComponent } from './view-service-package/view-service-package.component';
import { ViewAccountServicePackageComponent } from './view-account-service-package/view-account-service-package.component';
import { TicketDetailComponent } from './support/ticket-detail/ticket-detail.component';
import { StreamingComponent } from './streaming/streaming.component';
import { ViewJourneyDetailComponent } from './view-journey-detail/view-journey-detail.component';
import { NumberPipe } from './pipe/number.pipe';
import { RolePipe } from './pipe/role.pipe';
import { VehiclesComponent } from './vehicles/vehicles.component';
import { DevicesComponent } from './device/devices/devices.component';
import { ViewVehicleDetailComponent } from './view-vehicle-detail/view-vehicle-detail.component';
import { ViewDeviceDetailComponent } from './device/view-device-detail/view-device-detail.component';
import { ResetPwdLinkComponent } from './reset-pwd-link/reset-pwd-link.component';
import { DealerHomeComponent } from './dealers/dealer-home/dealer-home.component';
import { CustomersComponent } from './dealers/customers/customers.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { SearchComponent } from './search/search.component';
import { VehicleListTemplateComponent } from './template/vehicle-list-template/vehicle-list-template.component';
import { CustomerDetailComponent } from './dealers/customer-detail/customer-detail.component';
import { AccountUpdateComponent } from './account-update/account-update.component';
import { TcuDetailComponent } from './tcu-detail/tcu-detail.component';
import { AuthenticationService } from './service/authentication.service';
import { LocationListTemplateComponent } from './template/location-list-template/location-list-template.component';
import { ServicePackageListTemplateComponent } from './template/service-package-list-template/service-package-list-template.component';
import { UdrComponent } from './udr/udr.component';
import { ChargingComponent } from './charging/charging.component';
import { ViewServiceUsageComponent } from './view-service-usage/view-service-usage.component';
import { DongleProviderDashboardComponent } from './dongle-provider/dongle-provider-dashboard/dongle-provider-dashboard.component';
import { DongleProviderDetailComponent } from './dongle-provider/dongle-provider-detail/dongle-provider-detail.component';
import { DongleProviderAuthGuardService } from './service/dongle-provider-auth-guard.service';
import { DongleProviderUserRolesComponent } from './dongle-provider/dongle-provider-user-roles/dongle-provider-user-roles.component';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { UserListComponent } from './user-list/user-list.component';
import { ViewUserDetailComponent } from './view-user-detail/view-user-detail.component';
import { ServiceProviderDashboardComponent } from './service-provider/service-provider-dashboard/service-provider-dashboard.component';
import { ServiceProviderAccountManagementComponent } from './service-provider/service-provider-account-management/service-provider-account-management.component';
import { AccountBillingProfileComponent } from './account-billing-profile/account-billing-profile.component';
import { BillingComponent } from './billing/billing.component';
import { InvoiceComponent } from './billing/invoice/invoice.component';
import { AchComponent } from './billing/ach/ach.component';
import { BankCardComponent } from './billing/bank-card/bank-card.component';
import { PaymentOptionsComponent } from './billing/payment-options/payment-options.component';
import { InvoicePdfComponent } from './billing/invoice-pdf/invoice-pdf.component';
import { CardConnectComponent } from './billing/card-connect/card-connect.component';
import { SavedPaymentInstrumentsComponent } from './billing/saved-payment-instruments/saved-payment-instruments.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ViewInvoiceListComponent } from './invoices/view-invoice-list/view-invoice-list.component';
import { PaymentSettingsComponent } from './billing/payment-settings/payment-settings.component';
import { TransactionDetailComponent } from './invoices/transaction-detail/transaction-detail.component';
import { DonglesComponent } from './dongle-provider/dongles/dongles.component';
import { DeveloperAccessComponent } from './developer-access/developer-access.component';
import { TncComponent } from './tnc/tnc.component';
import { SmsMfaVerificationComponent } from './sms-mfa-verification/sms-mfa-verification.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SwaggerUiComponent } from './swagger-ui/swagger-ui.component';
import { TimeAgoExtendsPipe } from './pipe/time-ago-extends-pipe.pipe';
import { CertificatesComponent } from './certificates/certificates.component';
import { CertificateSummaryComponent } from './certificates/certificate-summary/certificate-summary.component';
import { VehicleListComponent } from './vehicle-list/vehicle-list.component';
import { CertificateDetailComponent } from './certificates/certificate-detail/certificate-detail.component';
import { ReviewVehiclesComponent } from './review-vehicles/review-vehicles.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NotificationsPageComponent } from './notifications-page/notifications-page.component';
import { EnvServiceProvider } from './provider/env.service.provider';
import { DeviceTypePipe } from './pipe/deviceType.pipe';
import { InvalidPageComponent } from './invalid-page/invalid-page.component';
import { EnrollVehicleComponent } from './enroll-vehicles/enroll-vehicles.component';
import { EnrollmentStatusComponent } from './enrollment-status/enrollment-status.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AccountPackagesComponent } from './account-packages/account-packages.component';
import { UserTncComponent } from './user-tnc/user-tnc.component';
import { EnrollmentErrorsComponent } from './enrollment-errors/enrollment-errors.component';
import { FaqsComponent } from './faq/faqs/faqs.component';
import { FaqDetailComponent } from './faq/faq-detail/faq-detail.component';
import { FaqComponent } from './faq/faq-list/faq/faq.component';
import { FaqOverviewComponent } from './faq/faq-list/faq-overview/faq-overview.component';
// import { VehicleJourneyComponent } from './vehicle-journey/vehicle-journey.component';
import { VehicleJourneyDetailComponent } from './vehicle-journey-detail/vehicle-journey-detail.component';
// import { VehicleStatusComponent } from './vehicle-status/vehicle-status.component';
// import { PreMatchComponent } from './pre-match/pre-match.component';
// import { VehicleStatusDetailComponent } from './vehicle-status-detail/vehicle-status-detail.component';
// import { LocationDetailDataComponent } from './location-detail-data/location-detail-data.component';
// import { AgmCoreModule } from '@agm/core';
// import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { LocationDetailModalComponent } from './location-detail-modal/location-detail-modal.component';
import { CorporateHomeComponent } from './corporate/corporate-home/corporate-home.component';
import { AddTcuDeviceComponent } from './tcu-detail/add-tcu-device/add-tcu-device.component';
import { ReviewDevicesComponent } from './review-devices/review-devices.component';
import { DeviceSummaryComponent } from './device/device-summary/device-summary.component';
import { VehicleSummaryComponent } from './device/vehicle-summary/vehicle-summary.component';
import { LinkDeviceToVehicleModalComponent } from './device/link-device-to-vehicle-modal/link-device-to-vehicle-modal.component';
import { DeviceHistoryComponent } from './device/device-history/device-history.component';
import { LanguagePreferenceComponent } from './language-preference/language-preference.component';
import { ViewAccountServicePackageNewComponent } from './view-account-service-package-new/view-account-service-package-new.component';
import { BusinessEntityComponent } from './business-entity/business-entity.component';
import { BeInvoiceDetailComponent } from './be-invoice-detail/be-invoice-detail.component';
import { BeInvoicesComponent } from './be-invoices/be-invoices.component';
import { VehicleHistoryEventComponent } from './vehicle-history-event/vehicle-history-event.component';
// import { NgxJsonViewerModule } from 'ngx-json-viewer';
// import { VehicleTripsComponent } from './vehicle-trips/vehicle-trips.component';
import { TripEventsComponent } from './trip-events/trip-events.component';
import { UserListTemplateComponent } from './template/user-list-template/user-list-template.component';
// import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { PascalCasePipe } from './pipe/pascal-case.pipe';
import { IntlPhoneInputComponent } from './intl-phone-input/intl-phone-input.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PhoneValidatorDirective } from './directives/phone-validator.directive';
import { PhoneFormatterDirective } from './directives/phone-formatter.directive';

const APP_ROUTES: Routes = [
  { path: '', component: LoginComponent },
  { path: 'password-reset', component: ResetPwdLinkComponent },
  { path: 'rental-fleet', component: HomeComponent },
  { path: 'account-management', component: AccountManagementComponent, canActivate: [AuthGuardService] },
  { path: 'service-packages', component: ServicePackagesComponent, canActivate: [AuthGuardService] },
  { path: 'service-package-detail', component: ServicePackageDetailComponent, canActivate: [AuthGuardService] },
  // { path: 'locations', component: LocationsComponent, canActivate: [AuthGuardService] },
  { path: 'admin-roles', component: AdminRolesComponent, canActivate: [AuthGuardService] },
  // { path: 'location/detail', component: LocationDetailComponent, canActivate: [AuthGuardService] },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService] },
  { path: 'admin/detail', component: AdminDetailComponent, canActivate: [AuthGuardService] },
  { path: 'support', component: SupportComponent, canActivate: [AuthGuardService] },
  { path: 'ticket-detail', component: TicketDetailComponent, canActivate: [AuthGuardService] },
  { path: 'udr', component: UsageComponent, canActivate: [AuthGuardService] },
  { path: 'usage', component: UdrComponent, canActivate: [AuthGuardService] },
  { path: 'charges', component: ChargingComponent, canActivate: [AuthGuardService] },
  { path: 'streaming', component: StreamingComponent, canActivate: [AuthGuardService] },
  { path: 'commercial-fleet', component: FmcAdminConsoleComponent, canActivate: [AuthGuardService] },
  { path: 'commercial-fleet/insights', component: InsightsComponent, canActivate: [AuthGuardService] },
  { path: 'commercial-fleet-dashboard', component: FmcDashboardComponent, canActivate: [AuthGuardService] },
  { path: 'vehicles', component: VehiclesComponent, canActivate: [AuthGuardService] },
  { path: 'dealer', component: DealerHomeComponent, canActivate: [AuthGuardService] },
  { path: 'customers', component: CustomersComponent, canActivate: [AuthGuardService] },
  { path: 'customer/detail', component: CustomerDetailComponent, canActivate: [AuthGuardService] },
  { path: 'provider/dashboard', component: DongleProviderDashboardComponent, canActivate: [AuthGuardService] },
  { path: 'provider/account-management', component: DongleProviderDetailComponent, canActivate: [AuthGuardService] },
  { path: 'provider/user-roles', component: DongleProviderUserRolesComponent, canActivate: [AuthGuardService] },
  { path: 'provider/dongles', component: DonglesComponent, canActivate: [AuthGuardService] },
  { path: 'service-provider/dashboard', component: ServiceProviderDashboardComponent, canActivate: [AuthGuardService] },
  { path: 'service-provider/account-management', component: ServiceProviderAccountManagementComponent, canActivate: [AuthGuardService] },
  // { path: 'billing', component: BillingComponent, canActivate: [AuthGuardService] },
  { path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuardService] },
  // { path: 'payment-settings', component: PaymentSettingsComponent, canActivate: [AuthGuardService] }
  { path: 'swagger-ui', component: SwaggerUiComponent, canActivate: [AuthGuardService] },
  { path: 'notifications', component: NotificationsPageComponent, canActivate: [AuthGuardService] },
  { path: 'certificates', component: CertificatesComponent, canActivate: [AuthGuardService] },
  { path: 'invalid', component: InvalidPageComponent, canActivate: [AuthGuardService] },
  { path: 'faq', component: FaqsComponent, canActivate: [AuthGuardService] },
  // { path: 'vehicle-journey', component: VehicleJourneyComponent, canActivate: [AuthGuardService] },
  // { path: 'vehicle-status', component: VehicleStatusComponent, canActivate: [AuthGuardService] },
  // { path: 'pre-match', component: PreMatchComponent },
  { path: 'corporate', component: CorporateHomeComponent, canActivate: [AuthGuardService] },
  { path: 'devices', component: DevicesComponent, canActivate: [AuthGuardService] },
  { path: 'business-entity', component: BusinessEntityComponent, canActivate: [AuthGuardService] },
  // { path: 'vehicle-trips', component: VehicleTripsComponent, canActivate: [AuthGuardService] },
  { path: 'trip-events', component: TripEventsComponent, canActivate: [AuthGuardService] }
];

@NgModule({
  declarations: [
    GroupByPipe,
    CustomTextPipe,
    UdrNotificationPipe,
    EmailMaskPipe,
    TimeAgoExtendsPipe,
    NumberPipe,
    RolePipe,
    DeviceTypePipe,
    AppComponent,
    HeaderComponent,
    HomeComponent,
    AccountManagementComponent,
    FooterComponent,
    ServicePackagesComponent,
    ServicePackageDetailComponent,
    // LocationsComponent,
    AdminRolesComponent,
    LocationDetailComponent,
    CompanyProfileComponent,
    LocationSettingsComponent,
    SettingsComponent,
    SecurityPoliciesComponent,
    AccountProfileComponent,
    AdminDetailComponent,
    SupportComponent,
    UsageComponent,
    LoginComponent,
    FmcAdminConsoleComponent,
    InsightsComponent,
    FmcDashboardComponent,
    ViewServicePackageComponent,
    ViewAccountServicePackageComponent,
    TicketDetailComponent,
    StreamingComponent,
    ViewJourneyDetailComponent,
    VehiclesComponent,
    CustomMinDirective,
    CustomMaxDirective,
    ViewVehicleDetailComponent,
    ResetPwdLinkComponent,
    DealerHomeComponent,
    CustomersComponent,
    SearchResultsComponent,
    SearchComponent,
    VehicleListTemplateComponent,
    CustomerDetailComponent,
    AccountUpdateComponent,
    TcuDetailComponent,
    LocationListTemplateComponent,
    ServicePackageListTemplateComponent,
    UdrComponent,
    ChargingComponent,
    ViewServiceUsageComponent,
    DongleProviderDashboardComponent,
    DongleProviderDetailComponent,
    DongleProviderUserRolesComponent,
    InviteUserComponent,
    UserListComponent,
    ViewUserDetailComponent,
    ServiceProviderDashboardComponent,
    ServiceProviderAccountManagementComponent,
    AccountBillingProfileComponent,
    BillingComponent,
    InvoiceComponent,
    AchComponent,
    BankCardComponent,
    PaymentOptionsComponent,
    InvoicePdfComponent,
    CardConnectComponent,
    SavedPaymentInstrumentsComponent,
    ConfirmationModalComponent,
    InvoicesComponent,
    ViewInvoiceListComponent,
    PaymentSettingsComponent,
    TransactionDetailComponent,
    DonglesComponent,
    DeveloperAccessComponent,
    TncComponent,
    SmsMfaVerificationComponent,
    ContactUsComponent,
    SwaggerUiComponent,
    CertificatesComponent,
    CertificateSummaryComponent,
    VehicleListComponent,
    CertificateDetailComponent,
    ReviewVehiclesComponent,
    NotificationsComponent,
    NotificationsPageComponent,
    InvalidPageComponent,
    EnrollVehicleComponent,
    EnrollmentStatusComponent,
    AccountPackagesComponent,
    UserTncComponent,
    EnrollmentErrorsComponent,
    FaqsComponent,
    FaqDetailComponent,
    FaqComponent,
    FaqOverviewComponent,
    // VehicleJourneyComponent,
    VehicleJourneyDetailComponent,
    // VehicleStatusComponent,
    // PreMatchComponent,
    // VehicleStatusDetailComponent,
    // LocationDetailDataComponent,
    LocationDetailModalComponent,
    CorporateHomeComponent,
    AddTcuDeviceComponent,
    DevicesComponent,
    ViewDeviceDetailComponent,
    ReviewDevicesComponent,
    DeviceSummaryComponent,
    VehicleSummaryComponent,
    LinkDeviceToVehicleModalComponent,
    DeviceHistoryComponent,
    LanguagePreferenceComponent,
    ViewAccountServicePackageNewComponent,
    BusinessEntityComponent,
    BeInvoiceDetailComponent,
    BeInvoicesComponent,
    VehicleHistoryEventComponent,
    // VehicleTripsComponent,
    TripEventsComponent,
    UserListTemplateComponent,
    PascalCasePipe,
    IntlPhoneInputComponent,
    PhoneValidatorDirective,
    PhoneFormatterDirective
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    CommonModule,
    BrowserAnimationsModule,
    // ToastrModule.forRoot({positionClass: 'toast-top-center'}),
    ToastrModule.forRoot(),
    RouterModule.forRoot(APP_ROUTES, { useHash: true, relativeLinkResolution: 'legacy' }),
    AccordionModule,
    CalendarModule,
    TimeagoModule.forRoot(),
    SharedModule,
    NgbModule,
    /* AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCJRjXqxaHphThBSI55BXlvspcRcHitptc'
    }), */
    //New Google key ashish: AIzaSyCJRjXqxaHphThBSI55BXlvspcRcHitptc
    //Old Google key Mam: AIzaSyDWuojEQmrE3fBXe82LEddrQiWbuJAulYw
    // AgmSnazzyInfoWindowModule,
    // NgxJsonViewerModule
    // NgxIntlTelInputModule,
    InfiniteScrollModule
  ],
  providers: [
    EnvServiceProvider,
    DatePipe,
    DecimalPipe,
    EmailMaskPipe,
    AdminRoleService,
    AuthenticationService,
    PascalCasePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
